import { useState } from "react";
import { Select } from "@bms-ai/bms-ai-ui-lib/components";
import type { Region } from "../../api/region-config";
import { useSession } from "../../context/session-context";
import DashboardLoadingOverlay from "../../components/DashboardLoadingOverlay/DashboardLoadingOverlay";
import "./RegionSelector.scss";

type RegionSelectorProps = {
  open: boolean;
  onSelect: (region: Region) => void;
};

const REGION_LABELS: Record<Region, string> = {
  us: "United States",
  de: "Germany",
  jp: "Japan",
};

export default function RegionSelector({
  open,
  onSelect,
}: RegionSelectorProps) {
  const { availableRegions } = useSession();
  const [selectedRegion, setSelectedRegion] = useState<Region | null>(null);

  const REGION_OPTIONS = availableRegions.map((region) => ({
    label: REGION_LABELS[region],
    value: region,
  }));

  const handleContinue = () => {
    if (selectedRegion) {
      onSelect(selectedRegion);
    }
  };

  const modalContent = (
    <div className="region-selector-modal">
      <h2>Select Your Region</h2>
      <p>Please select your region to continue.</p>

      <div className="select-dropdown-wrapper">
        <Select
          className="select-dropdown"
          options={REGION_OPTIONS}
          preSelectedOption={
            selectedRegion
              ? REGION_OPTIONS.find((opt) => opt.value === selectedRegion)
              : { label: "Select region", value: "" }
          }
          onSelect={(option) => {
            if (option.value && availableRegions.includes(option.value as Region)) {
              setSelectedRegion(option.value as Region);
            } else {
              setSelectedRegion(null);
            }
          }}
        />
      </div>

      <button
        type="button"
        onClick={handleContinue}
        disabled={!selectedRegion}
        className="region-continue-btn"
      >
        Continue
      </button>
    </div>
  );

  return (
    <DashboardLoadingOverlay open={open}>
      {modalContent}
    </DashboardLoadingOverlay>
  );
}
